import { DataService } from '../auth/DataService';
import { backend_url } from '../auth/setting';

const handleResponse = async (response) => {
  const text = await response.text();

  if (!response.ok) {
    let message = `HTTP ${response.status}`;
    try {
      const errorData = text ? JSON.parse(text) : {};
      message = errorData.message || errorData.error || message;
    } catch {
      if (text) message = text.slice(0, 200);
    }
    throw new Error(message);
  }

  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch {
    throw new Error('Failed to parse JSON response: ' + text.slice(0, 200));
  }
};

const apiRequest = async (endpoint, method = 'GET', data = null) => {
  const url = `${backend_url}${endpoint}`;
  const options = {
    method,
    mode: 'cors',
    headers: await DataService.getFetchHeader(
      endpoint,
      data ? { 'Content-Type': 'application/json' } : {}
    ),
    body: data ? JSON.stringify(data) : null,
  };

  const response = await fetch(url, options);

  if (response.status === 401) {
    await DataService.refreshToken(response.status);

    const optionsNew = {
      method,
      mode: 'cors',
      headers: await DataService.getFetchHeader(
        endpoint,
        data ? { 'Content-Type': 'application/json' } : {}
      ),
      body: data ? JSON.stringify(data) : null,
    };
    const responseNew = await fetch(url, optionsNew);

    return handleResponse(responseNew);
  }

  return handleResponse(response);
};

export const getData = (endpoint) => apiRequest(endpoint);

export const postData = (endpoint, data) => apiRequest(endpoint, 'POST', data);

export const putData = (endpoint, data) => apiRequest(endpoint, 'PUT', data);

export const patchData = (endpoint, data) =>
  apiRequest(endpoint, 'PATCH', data);

export const delData = (endpoint, data) => apiRequest(endpoint, 'DELETE', data);

export const postFormData = async (endpoint, formData) => {
  const url = `${backend_url}${endpoint}`;

  const headers = await DataService.getFetchHeader(endpoint);
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers,
    body: formData,
  });

  return handleResponse(response);
};

export const toQueryString = (params) =>
  params ? `?${new URLSearchParams(params).toString()}` : '';

export { DataService, backend_url };
